<template>
  <section class="flex level-1"  :class="{mobile:!mobile}">   
    <div class="block__law">
      <b-button @click.prevent="onItemClick" class="btn btn-send">
        {{general.openPdf}}
      </b-button>
    </div>
  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../../services/ApiService';
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'

export default {
  name:"ChallengesLawMobile",
    components:{ 
    }, 
    computed: {
      ...mapGetters([
        'getGeneral',
        'getChallengeSelected',
          'getIsMobile'
      ])
    },
    props:{
      mobile:{
        type:Boolean,
        default:true
      },      
    },    
    data () {
      return {   
        theLawId:'',
        theLink:''    
      }
    },
    created (){
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
      //
      this.getData(); 
    },    
    methods : {   
      async getData(){
        await ApiService.getConcoursApi().getReglement(this.getChallengeSelected,ApiAuthenticationService.getCurrentUser().type).then((data) => {
          this.theLawId = data.data;
          if (this.theLawId){
            this.theLink = ApiService.getMediaApi().get(this.theLawId);
          } else {
            this.theLink = null;
          }
        }, () => {
          this.theLawId = null;
          this.theLink = null;
        });

      },
      onItemClick(){
        window.open(this.theLink, '_blank');
      }      
    },
    watch : {
      'getChallengeSelected' : function (){
        this.getData();
      },
      getIsMobile(){
        this.isMobile = this.getIsMobile;
      }
    },    
};
</script>
